import { render, staticRenderFns } from "./CardFeatured.vue?vue&type=template&id=74355e45"
import script from "./CardFeatured.vue?vue&type=script&lang=js"
export * from "./CardFeatured.vue?vue&type=script&lang=js"
import style0 from "./CardFeatured.vue?vue&type=style&index=0&id=74355e45&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports